import {Model} from '@vuex-orm/core';
import Logger from "../Lib/Logger";

export default class BaseModel extends Model {
    static primaryKey = 'id';
    static route(){
        return null
    }
    static state(){
        return {
            loading: false,
            pagination: {
                next_page: null,
                prev_page: null,
                total_items: null,
                from: null,
                to: null,
                current_page: null,
                first_page: null,
                last_page: null,
                path: null,
            }
        }
    }

    static apiConfig = {
        actions: {
            async fetch(query, search = "", dataTransformer = null, save = true, next = false) {
                if(!this.model.route())return;
                let config = {
                    dataKey: (query && query.paginate) ? 'data' : undefined,
                    dataTransformer: (dataTransformer) ? dataTransformer : undefined,
                    params: query,
                    save: save,
                }
                let state = this.model.store().state.entities[this.model.entity];
                try{
                    // let get  = this.get(this.model.route() + search, config)
                    let get;
                    if(!next){
                        get = await this.get(this.model.route() + search, config)
                    }else{
                        let pageState = state.pagination;
                        let url = next.last ? pageState.last_page :
                            next.first ? pageState.first_page :
                                next.prev ? pageState.prev :
                                    next.toPage ? pageState.path+`?page=${next.toPage}` :
                                        pageState.next_page;
                        get = await this.get(url, config)
                    }
                    // if(save){
                        // console.log(get, 'get response')
                        // await this.model.customInsertOrUpdate(config.dataKey !== undefined ? get.response.data[config.dataKey] : get.response.data)
                    // }
                    if(config.dataKey){
                        state.pagination.next_page = get.response.data.next_page_url ? get.response.data.next_page_url.replace(/^(http|https)/, 'https') : get.response.data.next_page_url;
                        state.pagination.prev_page = get.response.data.prev_page_url ? get.response.data.prev_page_url.replace(/^(http|https)/, 'https') : get.response.data.prev_page_url;
                        state.pagination.total_items = get.response.data.total;
                        state.pagination.from = get.response.data.from;
                        state.pagination.to = get.response.data.last_page;
                        state.pagination.current_page = get.response.data.current_page;
                        state.pagination.first_page = get.response.data.first_page_url ? get.response.data.first_page_url.replace(/^(http|https)/, 'https') : get.response.data.first_page_url;
                        state.pagination.last_page = get.response.data.last_page_url ? get.response.data.last_page_url.replace(/^(http|https)/, 'https') : get.response.data.last_page_url;
                        state.pagination.path = get.response.data.path ? get.response.data.path.replace(/^(http|https)/, 'https') : get.response.data.path;
                    }
                    return get
                }catch(err){
                    console.log(err)
                    return false;
                }
            },
            async save(data) {
                // this.model.store().dispatch('showError', 'Data submits have been disabled during testing.');
                // throw new Error('Data submits have been disabled during testing.'); return;
                if(!this.model.route())return;
                let findOriginal = {};
                if(data.uuid){
                    findOriginal = this.model.find(data.uuid);
                    if(findOriginal){ findOriginal = {...findOriginal}}
                }
                let config = {};
                if(this.model.apiConfig.headers){
                    config.headers = {...this.model.apiConfig.headers, "VueRoute": window.location.href}
                }
                try{
                    let posted = await this.post(this.model.route(), data, config);
                    let id = null;
                    if(!data.id && Array.isArray(posted.response.data)){
                        id = posted.response.data[0].id;
                    }else if(!data.id){
                        id = posted.response.data.id;
                    }else{
                        id = data.id;
                    }
                    // Logger.save({
                    //     class: this.model.entity,
                    //     uuid: data.id ? data.id : id,
                    //     type: data.id ? "UPDATE" : "CREATE",
                    //     ignoredFields: this.model.ignoredLogFields(),
                    //     fields: this.model.fields(),
                    //     oldVal: findOriginal,
                    //     newVal: {...data},
                    //     user_id: this.model.store().getters.id,
                    //     user_name: this.model.store().getters.name,
                    // });
                    return posted;
                }catch(err){
                    console.log(err, 'err')
                    // Logger.devLog({
                    //     uuid: data.uuid ? data.uuid : null,
                    //     type: data.uuid ? "UPDATE" : "CREATE",
                    //     route: this.model.route(),
                    //     data: data,
                    //     error: JSON.stringify(err),
                    //     user_id: this.model.store().getters.id,
                    //     user_name: this.model.store().getters.name,
                    // })
                    return false;
                }

            },
            async destroy(id, message){
                console.log('destroy')
                if(!this.model.route())return;
                console.log('init destroy')
                let logObject = {
                    class: this.model.entity,
                    uuid: id,
                    deleted: message,
                    user_id: this.model.store().getters.id,
                    user_name: this.model.store().getters.name,
                }
                try{
                    let route = this.model.route() + (this.model.primaryKey === 'id' ? `/delete/${id}` : `/${id}`)
                    let deleted = await this.delete(route)
                    this.model.delete(id);
                    if(deleted.response.data === true){
                        // Logger.logDelete(logObject);
                        this.model.delete(id)
                    }
                    return deleted;
                }catch(err){
                    console.log(err);
                    // Logger.devLog({
                    //     uuid: uuid,
                    //     type: "DELETE",
                    //     route: this.model.route(),
                    //     data: null,
                    //     error: JSON.stringify(err),
                    //     user_id: this.model.store().getters.id,
                    //     user_name: this.model.store().getters.name,
                    // })
                    return false;
                }
            },
            async restore(uuid, message){
                if(!this.model.route())return;
                let logObject = {
                    class: this.model.entity,
                    uuid: uuid,
                    deleted: message,
                    user_id: this.model.store().getters.id,
                    user_name: this.model.store().getters.name,
                }
                try{
                    let restore = await this.post(this.model.route()+`/${uuid}/restore`)
                    if(restore.response.data === true){
                        Logger.logRestore(logObject);
                        this.model.update({
                            data: [{uuid: uuid, deleted_at: null}]
                        })
                    }
                    return restore;
                }catch(err){
                    Logger.devLog({
                        uuid: uuid,
                        type: "DELETE",
                        route: this.model.route(),
                        data: null,
                        error: JSON.stringify(err),
                        user_id: this.model.store().getters.id,
                        user_name: this.model.store().getters.name,
                    })
                    return false;
                }
            }
        }
    }
    //TODO: Keeping this until completion of MVP just in-case importing the logger messes anything up.
    // static apiConfig = {
    //     actions: {
    //         fetch(query, search = "") {
    //             console.log(this.model.route())
    //             if(!this.model.route())return;
    //             return this.get(this.model.route() + search, {
    //                 params: query,
    //             })
    //         },
    //         async save(data) {
    //             if(!this.model.route())return;
    //             let posted = await this.post(this.model.route(), data);
    //             return posted;
    //         }
    //     }
    // }
}
